import _isArray from 'lodash/isArray';
import { isObservableArray } from 'mobx';

export default function isArray(arr: unknown) {
  return Boolean(_isArray(arr) || isObservableArray(arr));
}
